module.exports = __webpack_public_path__ + "components/MapControl/svg/Cmentarz.svg?4b3eabc5";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Cmentarz.svg
// module id = 1918
// module chunks = 0